// src/pages/Register/StepAgency.jsx

import { useContext } from "react";
import InputPro from "../../components/ui/InputPro";
import Button from "../../components/ui/Button";
import { LanguageContext } from "../../context/LanguageContext";
import { checkAgencyeName } from "../../api/auth";

export default function StepAgency({
  profileData,
  updateProfileData,
  prevStep,
  submit,
  loading,
  updateErrors,
  errors,
}) {
  const { t, lang } = useContext(LanguageContext);
  const isRTL = lang === "ar";

  /* =========================
      HANDLE CHANGE
  ========================= */
  const handleChange = async (e) => {
    const { name, value } = e.target;

    updateProfileData({ [name]: value });
    updateErrors({ [name]: "" });

    // Agency name async check
    if (name === "agency_name" && value.trim()) {
      const res = await checkAgencyeName({ agency_name: value });

      if (res.data?.exists) {
        updateErrors({ agency_name: t("agency.taken") });
      } else {
        updateErrors({ agency_name: "" });
      }
    }
  };

  /* =========================
      VALIDATION
  ========================= */
  const validateBeforeSubmit = () => {
    let ok = true;

    const requiredFields = ["agency_name", "industry"];
    requiredFields.forEach((field) => {
      if (!profileData[field]?.trim()) {
        updateErrors({ [field]: t("auth.required") });
        ok = false;
      }
    });

    if (errors.agency_name) ok = false;

    if (ok) submit();
  };

  return (
    <div className="space-y-6" dir={isRTL ? "rtl" : "ltr"}>
      {/* TITLE */}
      <h2
        className={`text-xl font-semibold text-gray-900 dark:text-white ${
          isRTL ? "text-right" : "text-left"
        }`}
      >
        {t("agency.title")}
      </h2>

      {/* AGENCY NAME */}
      <InputPro
        label={t("agency.name")}
        name="agency_name"
        required
        value={profileData.agency_name || ""}
        onChange={handleChange}
        error={errors.agency_name}
      />

      {/* INDUSTRY */}
      <InputPro
        label={t("agency.industry")}
        name="industry"
        required
        value={profileData.industry || ""}
        onChange={handleChange}
        error={errors.industry}
      />

      {/* ACTIONS */}
      <div
        className={`flex gap-3 pt-4 ${
          isRTL ? "flex-row-reverse" : ""
        }`}
      >
        <Button variant="secondary" onClick={prevStep}>
          {t("common.back")}
        </Button>

        <Button
          variant="primary"
          loading={loading}
          onClick={validateBeforeSubmit}
        >
          {t("agency.submit")}
        </Button>
      </div>
    </div>
  );
}
